module.exports = __webpack_public_path__ + "img/FoundationAssociation.2710e94e.svg";